/**
 * 此监控上报组件，仅用于sdk内部监控/告警上报。
 * 与main/index.js中提供的监控上报方法解耦。
 * 避免在各流程中复用业务监控上报，造成循环调用。
 */
import M_AXIOS from './../axios/index.js'
import M_BRIDGE from './../../../weex/components/bridge/index.js'
import M_URL from './../url/index.js'
import M_UA_PARSER from '../ua_parser/index.js'
import M_ENV from './../env/index.js'
import M_TOOLKIT from './../toolkit/index.js'

import { G_APP_LOG_TYPE_MAP } from './../../../config/index.js'

const MONITOR_TEMPLE = () => {
    return {
        record_type: G_APP_LOG_TYPE_MAP.monitor, // 监控行为
        time: M_TOOLKIT.getTime(), // 时间戳
        page_name: '', // 页面名称，一般不需要传递由app取统跳的值或取页面title
        page_url: '', // 页面路径 如果有传递则依据传递值为准，无则app自行获取
        refer_url: '', // referer_url路径 如果有传递则依据传递值为准，无则app自行获取
        page_points: {}, // 测速点
        extend_info: {} // 扩展信息
    }
}

// web实际上报的数据
const WEB_REPORT_OBJ = () => {
    return {
        action: 'uploadWebDataSingleReport',
        content: {
            public: {},
            data: {
                record_list: [],
                record_type: G_APP_LOG_TYPE_MAP.monitor // 监控行为
            }
        }
    }
}

/** --------------------------------------私有方法----------------------------------------- **/
// 获取通用数据
let _getCommonData = () => {
    let common_data = {}

    let public_common_data = {
        app_id: 'com.lexin.lx_report_monitor'
    }

    if (!M_ENV.isInApp) {
        // 设备信息采集
        let ua_uarse = new M_UA_PARSER()

        let { os, device, ua } = ua_uarse.getResult()
        
        Object.assign(public_common_data, {
            ua: ua,
            device_system: os.name,
            device_system_version: os.version,
            device_model: device.model,
            device_brand: device.vendor
        })

        // 页面信息
        let page_info = {}
        let url_info = M_URL.getUrl()

        url_info.crtUrl ? page_info.page_url = url_info.crtUrl : ''
        url_info.refUrl ? page_info.refer_url = url_info.refUrl : ''

        if (M_ENV.isWeexNativeInApp) {
            page_info.page_type = 'weex'
        } else if (M_ENV.isMp) {
            page_info.page_type = 'mp'
        } else {
            page_info.page_type = 'h5'
        }

        Object.assign(common_data, page_info)

        // 网络信息
        let connection_info = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {}
        let connection = (connection_info.effectiveType || connection_info.type || 'UNKNOWN').toUpperCase()

        Object.assign(common_data, {
            net_type: connection
        })
    }

    return {
        publicCommonData: public_common_data,
        commonData: common_data
    }
}

/** --------------------------------------私有方法----------------------------------------- **/

/** --------------------------------------对外公用方法----------------------------------------- **/
let monitor = {
    monitorReport: (params) => {
        let monitor_obj = MONITOR_TEMPLE() // 返回模板
    
        // 合并上报字段
        Object.assign(monitor_obj, params)
    
        let common_data = _getCommonData()
    
        Object.assign(monitor_obj, common_data.commonData)

        // APP内
        if (M_ENV.isInApp) {
            // 将上报消息体取出，由APP上报
            let has_data = M_TOOLKIT.isObject(monitor_obj) && !M_TOOLKIT.isEmptyObject(monitor_obj)

            has_data && M_BRIDGE.invoke('unifyReport', {
                params: monitor_obj,
                callback: () => {}
            })
        } else { // H5
    
            let report_data = WEB_REPORT_OBJ()
            Object.assign(report_data.content.public, common_data.publicCommonData)
            
            // web上报统一删除record_type键值
            delete monitor_obj['record_type']

            // 推入本次上报数据，暂不支持批量上报
            report_data.content.data.record_list.push(monitor_obj)
     
            M_AXIOS.post('https://dc.fenqile.com/route0031/dataCollect/uploadWebDataSingleReport.json', { 
                data: report_data 
            })
        }
    },
    errorReport: (params) => {
        let tpl = {
            error_type: 'h5_report_js_error',
            business_id: 'lx_behavior_js_sdk'
        }
        params.error_log_info = Object.assign(tpl, params.error_log_info)

        monitor.monitorReport(params)
    }
}

/** --------------------------------------对外公用方法----------------------------------------- **/

export default monitor